'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitAtLeastSeconds = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _index = require('./index');

/**
 * Ensures that the promise takes at least a certain amount of time until it resolves.
 * Might be used to prevent UI flickering when the API responds very fast.
 * @param {number} seconds
 * @returns {function}
 * @expamle
 * import { waitAtLeastSeconds } from 'promise-frites';
 *
 * const waitAtLeast1Second = waitAtLeastSeconds(1);
 * const apiCall = Promise.resolve('my api data');
 *
 * Promise.resolve()
 *   .then(waitAtLeast1Second(apiCall))
 *   .then((data) => data === 'my api data');
 */
var waitAtLeastSeconds = exports.waitAtLeastSeconds = function waitAtLeastSeconds(seconds) {
  return function (action) {
    return function (args) {
      return Promise.all([action(args), (0, _index.delay)(seconds)]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            actionResult = _ref2[0];

        return actionResult;
      });
    };
  };
};